import React from 'react';
import PropTypes from 'prop-types';

const CapitalizeRenderer = (props) => {
  const value = props.value;

  const capitalized =
    typeof value === 'string' && value.length > 0
      ? value.charAt(0).toUpperCase() + value.slice(1)
      : value;

  return (
    <span>{capitalized}</span>
  );
};

CapitalizeRenderer.propTypes = {
  value: PropTypes.string
};

export default CapitalizeRenderer;
